import { NavbarNested as BPNavbar } from '../NavbarNested';
import { links } from './_links';

export const Navbar = () => {
  return <BPNavbar testid="NavBar" links={links} />;
};

export default Navbar;
